<template>
    <div>
<!--        The task workflow <strong>{{ $_.get(activity, "payload.name") }}</strong> was created by-->
<!--        <strong>{{ $_.get(activity, "actorUser.name") }}</strong>.-->
        <span v-html="$t('notification.taskWFlowCreated', {user:$_.get(activity, 'actorUser.name'),Wflow:$_.get(activity, 'payload.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "TaskWorkflowCreated",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
